import React from "react";
import dynamic from "next/dynamic";

const UseCaseBanner = dynamic(() => import("./use-case-banner"));
const UseCaseActors = dynamic(() => import("./use-case-actors"));
const UseCaseMainFlow = dynamic(() => import("./use-case-main-flow"));
const SuggestedTechStack = dynamic(() => import("./suggested-tech-stack"));
const UseCaseIntroduction = dynamic(() => import("./use-case-introduction"));
const UseCaseAlternateFlow = dynamic(() => import("./use-case-alternate-flow"));
const UseCasePreConditions = dynamic(() => import("./use-case-pre-conditions"));
const UseCta = dynamic(() => import("@/Components/pages/blog/detail/blog-cta"));
const UseCasePostConditions = dynamic(
  () => import("./use-case-post-conditions")
);

interface Block {
  __component: string;
  [key: string]: any; // fallback for extra fields
}

interface UseCaseDetailsProps {
  data: {
    blocks?: Block[];
    [key: string]: any;
  };
}

const UseCaseDetails: React.FC<UseCaseDetailsProps> = ({ data  }) => {
  const cta: any = data?.blocks?.find(
    (block: any) => block.__component === "blocks.cta"
  );
  return (
    <div className="middle-inner">
      <UseCaseBanner block={data} />
      {data?.blocks && data.blocks.length > 0 && (
        <>
          {data?.blocks.map((block: any, i: number) => (
            <React.Fragment key={i}>
              {block.__component === "blocks.use-case-introduction" && (
                <UseCaseIntroduction block={block} />
              )}
              {block.__component === "blocks.use-case-actors" && (
                <UseCaseActors block={block} />
              )}
              {block.__component === "blocks.use-case-pre-conditions" && (
                <UseCasePreConditions block={block} />
              )}
              {block.__component === "blocks.use-case-post-conditions" && (
                <UseCasePostConditions block={block} />
              )}
              {block.__component === "blocks.use-case-main-flow" && (
                <UseCaseMainFlow block={block} />
              )}
              {block.__component === "blocks.use-case-alternate-flow" && (
                <UseCaseAlternateFlow data={block} />
              )}

              {block.__component === "blocks.suggested-tech-stack" && (
                <SuggestedTechStack data={block} isMobile={false} slug={""} />
              )}
              {/* {block.__component === "blocks.cta" && <UseCta block={block} />} */}
            </React.Fragment>
          ))}
        </>
      )}
      {cta?.id && <UseCta block={cta} />}
    </div>
  );
}

export default UseCaseDetails;
